import HomeNavbar from "../sections/home/HomeNavbar";
import HomeAppShowcase from "../sections/home/HomeAppShowcase";
import HomeStats from "../sections/home/HomeStats";
import HomeWhatWeDo from "../sections/home/HomeWhatWeDo";
import HomeHowItWorks from "../sections/home/HomeHowItWorks";
import HomeProjects from "../sections/home/HomeProjects";
import HomeFAQ from "../sections/home/HomeFAQ";
import HomeCTA from "../sections/home/HomeCTA";
import HomeFooter from "../sections/home/HomeFooter";

/**
 * Hero → proof → capability → process → evidence → price → objections → action.
 *
 * Deliberately one idea per section, alternating white and #F5F7FA so the eye
 * always knows where a section starts. The previous page interleaved two
 * overlapping feature sections carrying 18 mockup components, which is what
 * made the scroll feel confusing.
 */
export default function HomePage() {
  return (
    <>
      <HomeNavbar />
      <HomeAppShowcase />
      <HomeStats />
      <HomeWhatWeDo />
      <HomeHowItWorks />
      <HomeProjects />
      <HomeFAQ />
      <HomeCTA />
      <HomeFooter />
    </>
  );
}
